const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 16,
    color: "#FFFFFF",
    boxShadow: "none"
  }),
  cometPaper: theme.mixins.gutters({
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: -18,
    color: "#FFFFFF",
    boxShadow: "none"
  }),
  result: {
    flexGrow: 1
  },
  flex: {
    flexGrow: 1
  },
  buttons: {
    textAlign: "right"
  },
  link: {
    marginLeft: 10,
    marginRight: 10
  },
  testPass: {
    backgroundColor: "#4caf50"
  },
  testFail: {
    backgroundColor: "#ff5252"
  },
  resultNav: {
    padding: "4px!important",
    height: "40px"
  },
  resultButtons: {
    padding: "0!important",
    height: "40px",
    textAlign: "center"
  },
  nav: {
    textAlign: "center",
    "& a": {
      width: "30px",
      height: "30px",
      minHeight: "unset"
    }
  },
  status: {
    textAlign: "center",
    //paddingTop: "9px",
    fontSize: "1rem !important"
  },
  resultsViewer: {
    flex: 2
  },
  table: {
    padding: "4px 0px 4px 0px"
  },
  success: {
    backgroundColor: "#43A547"
  },
  fail: {
    backgroundColor: "#ff5252"
  },
  unknown: {
    backgroundColor: "#72757A"
  },
  text: {
    paddingTop: "9px",
    fontSize: "1rem",
    fontWeight: "500",
    width: "100%",
    paddingRight: "0",
    color: "white",
    letterSpacing: "0.5px"
  },
  headerText: {
    paddingTop: "0px",
    fontSize: "1rem",
    fontWeight: "500",
    width: "100%",
    paddingRight: "0",
    color: "white",
    letterSpacing: "0.5px"
  },
  chartSettings: {
    color: "#FFFFFF"
  },
  menuItem: {
    height: "auto",
    color: "red"
  },
  radiogroup: {
    textTransform: "uppercase",
    fontSize: "11px",
    color: "#A2AABD"
  },
  cardActionsNav: {
    color: "white"
  },
  resultBar: {
    lineHeight: "40px",
    paddingTop: "0!important",
    paddingBottom: "0!important",
    textAlign: "center",
    borderRight: "1px solid #D6D6D6",
    fontSize: "0.8rem",
    height: 40,
    "& h3": {
      lineHeight: "40px",
      textAlign: "center",
      fontSize: "0.8rem"
    },
    "& span": {
      fontSize: "0.8rem"
    }
  },
  resultBarDropDown: {
    width: "100%",
    padding: "0 8px",
    height: "40px",
    "& div": {
      width: "100%"
    }
  },
  selectItem: {
    fontSize: "0.9rem",
    fontWeight: "500",
    color: "white",
    paddingBottom: "1%"
  },
  resultsDD: {
    "& > div": {
      fontSize: "1rem",
      fontWeight: "500",
      width: "100%",
      paddingRight: "0",
      color: "white",
      letterSpacing: "0.5px"
    }
  },
  settingsMenu: {
    color: "red"
  },
  attachmentExists: {
    backgroundColor: "#FF7043",
    //'& span:first-child':{
    //},
    "&:hover": {
      backgroundColor: "#FF7043"
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/results/styles.js